import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer18 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Vintage Sarees', path: '/template18/shop' },
        { label: 'Heritage Kurtas', path: '/template18/shop' },
        { label: 'Classic Shawls', path: '/template18/shop' },
        { label: 'Antique Jewelry', path: '/template18/shop' },
        { label: 'Retro Accessories', path: '/template18/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template18/contact' },
        { label: 'Shipping Policy', path: '/template18/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template18/shipping-exchange' },
        { label: 'FAQs', path: '/template18/faqs' },
        { label: 'Track Order', path: '/template18/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Vollkorn:wght@400;600;700&family=Work+Sans:wght@300;400;500&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#7C2D12' }}>
                {/* Vintage Divider */}
                <div style={{ textAlign: 'center', padding: '24px 0 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
                        <div style={{ width: '80px', height: '1px', backgroundColor: '#A0845C' }} />
                        <span style={{ color: '#A0845C', fontSize: '20px' }}>&#10043;</span>
                        <div style={{ width: '80px', height: '1px', backgroundColor: '#A0845C' }} />
                    </div>
                </div>

                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '48px 24px',
                    }}
                    className="purani-footer-main"
                >
                    <div className="purani-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Vollkorn', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#FAF3EB',
                                    letterSpacing: '2px',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                PURANI DILLI
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Work Sans', sans-serif",
                                    fontSize: '14px',
                                    color: '#D4C5B0',
                                    lineHeight: 1.7,
                                    margin: '0 0 20px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Heritage Never Goes Out of Style
                            </p>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {[Instagram, Facebook].map((Icon, idx) => (
                                    <a
                                        key={idx}
                                        href="#"
                                        style={{
                                            width: '38px',
                                            height: '38px',
                                            border: '1px solid #A0845C',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FAF3EB',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#A0845C';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={16} />
                                    </a>
                                ))}
                                <a
                                    href="#"
                                    style={{
                                        width: '38px',
                                        height: '38px',
                                        border: '1px solid #A0845C',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#FAF3EB',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#A0845C';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Vollkorn', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#A0845C',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Work Sans', sans-serif",
                                                fontSize: '14px',
                                                color: '#FAF3EB',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#A0845C')}
                                            onMouseLeave={(e) => (e.target.style.color = '#FAF3EB')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Vollkorn', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#A0845C',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Work Sans', sans-serif",
                                                fontSize: '14px',
                                                color: '#FAF3EB',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#A0845C')}
                                            onMouseLeave={(e) => (e.target.style.color = '#FAF3EB')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Vollkorn', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#A0845C',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Mail size={16} style={{ color: '#A0845C', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Work Sans', sans-serif", fontSize: '14px', color: '#FAF3EB' }}>
                                        hello@puranidilli.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Phone size={16} style={{ color: '#A0845C', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Work Sans', sans-serif", fontSize: '14px', color: '#FAF3EB' }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                    <MapPin size={16} style={{ color: '#A0845C', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Work Sans', sans-serif", fontSize: '14px', color: '#FAF3EB', lineHeight: 1.6 }}>
                                        Chandni Chowk, Old Delhi, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{ borderTop: '1px solid rgba(160, 132, 92, 0.3)' }}>
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '20px 24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '12px',
                            }}
                            className="purani-footer-bottom"
                        >
                            <p style={{ fontFamily: "'Work Sans', sans-serif", fontSize: '12px', color: '#D4C5B0', margin: 0 }}>
                                &copy; 2026 Purani Dilli. All rights reserved.
                            </p>
                            <p style={{ fontFamily: "'Work Sans', sans-serif", fontSize: '12px', color: '#D4C5B0', margin: 0, fontStyle: 'italic' }}>
                                Woven with heritage in India
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#6B2410" stroke="#A0845C" strokeWidth="0.5" />
                                    <text x="18" y="14" textAnchor="middle" fill="#D4C5B0" fontSize="8" fontWeight="bold" fontFamily="Work Sans, sans-serif">VISA</text>
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#6B2410" stroke="#A0845C" strokeWidth="0.5" />
                                    <circle cx="15" cy="12" r="5" fill="#A0845C" opacity="0.5" />
                                    <circle cx="21" cy="12" r="5" fill="#A0845C" opacity="0.5" />
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#6B2410" stroke="#A0845C" strokeWidth="0.5" />
                                    <text x="18" y="14" textAnchor="middle" fill="#D4C5B0" fontSize="7" fontWeight="bold" fontFamily="Work Sans, sans-serif">UPI</text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .purani-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 40px;
                    }
                    @media (max-width: 768px) {
                        .purani-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 32px;
                        }
                        .purani-footer-main {
                            padding: 32px 24px !important;
                        }
                        .purani-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .purani-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer18;
